import React from "react";

const FactsSkeleton: React.FC = () => {
  return (
    <>
      <div>
        <section className="section relative text-white py-10 max-sm:py-6 max-sm:px-4 z-[1] blue-bg-dots">
          <div className="container mx-auto !px-0">
            <h2 className="text-[#91DBE7] text-6xl max-md:text-4xl max-sm:text-3xl text-start mb-8 max-sm:mb-6 break-all">
              <div className="h-14 max-sm:h-8 max-sm:w-full w-96 max-md:w-56 bg-gray-300 skeleton rounded"></div>
            </h2>

            <div className="flex items-center justify-center max-sm:flex-wrap gap-2">
              <div className="h-[500px] max-w-[500px] w-full bg-gray-300 skeleton rounded"></div>
              <div className="mt-56 max-md:mt-36 max-sm:mt-10 max-w-[500px] w-full text-end">
                <div className="h-[500px] max-w-[500px] w-full bg-gray-300 skeleton rounded"></div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default FactsSkeleton;
